import { Chip, Tooltip } from '@mui/material';

import type { OrderStatus } from '../../api/business/types';
import { useT } from '../../i18n/LanguageContext';

const COLOURS: Record<OrderStatus, 'default' | 'success' | 'warning' | 'info' | 'error' | 'primary'> = {
  NEW: 'info',
  PAID: 'primary',
  PROCESSING: 'warning',
  SHIPPED: 'primary',
  DELIVERED: 'success',
  CANCELLED: 'default',
  RETURNED: 'error',
  OTHER: 'default',
};

/** An order's status in the app's words; the shop's own name for it on hover — both are what the shop said. */
export const OrderStatusChip = ({ status, label }: { status: OrderStatus; label: string }) => {
  const t = useT();

  return (
    <Tooltip title={label}>
      <Chip
        size="small"
        variant="outlined"
        color={COLOURS[status]}
        label={t(`orderStatus.${status}` as const)}
      />
    </Tooltip>
  );
};
